import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { analysisData } from '../../Redux/Slices/adminPortalSlice';
import ReactLoading from 'react-loading';
import HorizontalBarChart from '../../Charts/HorizontalBarChart';
import Doughnut1 from '../../Charts/Doughnut1';
import Doughnut2 from '../../Charts/Doughnut2';
import Doughnut3 from '../../Charts/Doughnut3';
import './WebAnalysis.css';

function WebAnalysis() {
    let data = useSelector(analysisData)
    if (data === 'unloaded') {
        return (
            <div className="WebAnalysis_loadingDiv">
                <ReactLoading type={'bubbles'} color={'#00695f'} height={100} width={100} />
            </div>
        )
    } else {
        return (
            <>
                <div className="WebAnalysis_dashboardDiv1">

                    <div className='WebAnalysis_clikedUserDiv'>
                        <div className='WebAnalysis_clikedUserDetails'>
                            <div className='WebAnalysis_clikedUserNumber'>{`${data.totalClickedUsers}`}</div>
                            <div className='WebAnalysis_clikedUserDesc'>Total number of Website visitors</div>
                        </div>
                        <div className='WebAnalysis_clikedUserFooter'>Website visitors</div>
                    </div>

                    <div className='WebAnalysis_signinDiv'>
                        <div className='WebAnalysis_signinDetails'>
                            <div className='WebAnalysis_signinNumber'>{`${data.loginUsers}`}</div>
                            <div className='WebAnalysis_signinDesc'>Total number of Login users</div>
                            <div className='WebAnalysis_signinStats'>{`${((data.loginUsers / data.totalClickedUsers) * 100).toFixed(2)} % of Website visitors`}</div>
                        </div>
                        <div className='WebAnalysis_signinFooter'>Login users</div>
                    </div>

                    <div className="WebAnalysis_referresDiv">
                        <HorizontalBarChart />
                    </div>


                </div>

                <div className="WebAnalysis_dashboardDiv2">
                    <div className="WebAnalysis_deviceSection" >
                        <Doughnut1 />
                    </div>

                    <div className="WebAnalysis_languageSection" >
                        <Doughnut2 />
                    </div>

                    <div className="WebAnalysis_browserSection" >
                        <Doughnut3 />
                    </div>
                </div>
            </>
        )
    }
}
export default WebAnalysis;